'use strict';
/* ==========================================================================
   levels/title.js — title screen: paper collage, Newton under the apple
   branch (apple-bonk gag every 6 s), ransom title, big ▶ Play button.
   Levels.title.loading() draws the "cutting paper…" screen used by Game
   while assets load (no paper textures exist yet, so plain fills + ink only).
   ========================================================================== */
(function () {
  const PLAY = { x: 1400, y: 790 };
  const NEWT = { x: 560, y: 1110, h: 800 };
  const BRANCH = [[-40, 110], [180, 90], [380, 118], [560, 96], [760, 128], [900, 112]];
  const LEAVES = [[260, 70, -0.5], [470, 150, 0.6], [520, 45, -0.9], [700, 80, 0.2], [820, 150, 0.9], [150, 130, 0.3]];
  const GAG_FIRST = 2.5, GAG_EVERY = 6, GAG_LEN = 3.4, APPLE_H = 160, HANG_Y = 215;

  function paperBase() {
    g.fillStyle = PAL.paper; g.fillRect(0, 0, Game.W, Game.H);
    if (IMG.tex_paper) { g.save(); g.globalAlpha = 0.9; g.drawImage(IMG.tex_paper, 0, 0, Game.W, Game.H); g.restore(); }
    g.save(); g.globalAlpha = 0.45; g.fillStyle = paperTile(PAL.paper, 9); g.fillRect(0, 0, Game.W, Game.H); g.restore();
  }

  class Title extends Scene {
    enter() { this.started = false; }

    go(toMap = false) {
      if (this.started) return;
      this.started = true;
      Audio.unlock();
      // Video first, then the lessons. The video scene silences the game music while it
      // plays and brings it back on the way to the map.
      // (window.__SKIP_VIDEO is set only by the headless test harness, so level tests start at the map.)
      if (!toMap && typeof Levels.video === 'function' && !window.__SKIP_VIDEO) { Game.replace(new Levels.video()); return; }
      Audio.music(Game.MUSIC, { gain: 0.35 });
      Game.replace(new Levels.map());
    }

    keyDown(k) { if (k === 'Enter' || k === ' ') this.go(); }

    draw() {
      UI.allLessons();                       // "← All lessons": back to the site's home page (core/ui.js)
      const t = this.t, t0 = this.enteredAt;
      paperBase();
      // background collage
      texScrap('tex_graph', 1420, 470, 1000, 860, { rot: 0.035, seed: 5, depth: 1.2 });
      texScrap('tex_news', 250, 930, 680, 400, { rot: -0.08, seed: 6, depth: 1, tint: PAL.mustard, tintAlpha: 0.12 });
      paperRect(1640, 1000, 720, 170, PAL.teal, { seed: 7, rot: -0.03, torn: true, depth: 1 });
      paperCircle(1790, 120, 86, PAL.mustard, { seed: 8, depth: 0.8 });
      tape(1000, 58, 170, -0.2, undefined, 2); tape(1860, 880, 150, 0.6, undefined, 3);
      doodleStar(1080, 250, 26, { seed: 3, rot: T * 0.4, s: pop(T, t0 + 1.2) });
      doodleStar(1820, 560, 20, { seed: 4, rot: -T * 0.5, color: PAL.pink, s: pop(T, t0 + 1.4) });

      // branch + leaves
      ink(BRANCH, { w: 16, seed: 11, prog: E.outCubic(P(T, t0 + 0.1, t0 + 0.8)), color: '#4a3526', amp: 2 });
      ink([[380, 118], [470, 60], [540, 40]], { w: 8, seed: 12, prog: P(T, t0 + 0.5, t0 + 0.9), color: '#4a3526' });
      ink([[560, 96], [620, 150], [640, 190]], { w: 6, seed: 13, prog: P(T, t0 + 0.55, t0 + 0.9), color: '#4a3526' });
      LEAVES.forEach((l, i) => paperPiece(blobPts(46, 22, 30 + i, 0.08, 20), l[0], l[1], i % 2 ? PAL.green : '#8bbf5e',
        { rot: l[2] + Math.sin(T * 2 + i) * 0.05, s: pop(T, t0 + 0.6 + i * 0.06), seed: 30 + i, depth: 0.8 }));

      // apple gag: hang (wobble before the drop) → UI.newton 'bonk' does fall, bonk, stars, bounce
      let gagT0 = null;
      if (t >= GAG_FIRST) {
        const k = Math.floor((t - GAG_FIRST) / GAG_EVERY);
        const cand = t0 + GAG_FIRST + k * GAG_EVERY;
        if (T < cand + GAG_LEN) gagT0 = cand;
      }
      const [hx] = UI._newtonHead(NEWT.x, NEWT.y, NEWT.h);
      const ax = hx + 10;
      UI.newton(NEWT.x, NEWT.y, { h: NEWT.h, mood: gagT0 !== null ? 'bonk' : 'idle', t0: gagT0, appleY: HANG_Y });
      if (gagT0 === null) {
        // hanging apple, re-grown after each gag; wobbles in the 0.5 s before it falls
        const next = t0 + GAG_FIRST + Math.max(0, Math.ceil((t - GAG_FIRST) / GAG_EVERY)) * GAG_EVERY;
        const grown = t < GAG_FIRST ? pop(T, t0 + 0.9) : pop(T, next - GAG_EVERY + GAG_LEN, 0.4);
        const wob = Math.sin((T - next) * 26) * 0.12 * P(T, next - 0.5, next - 0.3);
        ink([[ax, 128], [ax + wob * 30, HANG_Y - APPLE_H * 0.42]], { w: 4, seed: 15, color: '#4a3526' });
        UI._apple(ax, HANG_Y, APPLE_H, { rot: wob, s: grown, look: [0.3 * Math.sin(T * 2), 1], blink: (T % 4.1) < 0.12 ? 1 : 0 });
      } else if (T < gagT0 + 0.45) {
        ink([[ax, 128], [ax, 150]], { w: 4, seed: 15, color: '#4a3526' });   // snapped stalk
      }

      // title
      ransom("NEWTON'S", 1400, 250, 104, t0 + 0.5, { seed: 101 });
      ransom('LAWS', 1400, 410, 128, t0 + 0.95, { seed: 202 });
      hand('the game', 1470, 560, 100, t0 + 1.45, { dur: 0.45, color: PAL.navy, rot: -0.04 });
      ink([[1250, 615], [1420, 605], [1620, 613]], { w: 6, seed: 19, prog: P(T, t0 + 1.8, t0 + 2.05), color: PAL.red });

      // portrait phone: the title's controls are in the dock (core/dock.js Dock.title); "Continue" (a stamp earned) skips the film
      if (UI.docked()) { Dock.title({ onStart: () => this.go(), onContinue: () => this.go(true) }); return; }
      if (t > 1.6 && UI.button('play', '▶ Play', PLAY.x, PLAY.y, { w: 440, h: 140, color: PAL.red, font: "'Luckiest Guy'", size: 72, rot: -0.03 })) this.go();
      // the T key only when a keyboard is in use; on a touch screen the ✎ on every level does the same
      if (t > 3) hand(UI.hint('(press T any time for teacher mode)', '(✎ on any level = teacher mode)'), 1400, 920 + (UI.tap(140) - 140) / 2, UI.text(38), t0 + 3, { color: 'rgba(43,36,32,0.7)', seed: 61 });
    }
  }
  Title.PLAY = PLAY;

  /* loading screen: no textures yet → plain paper colour, ink scissors snipping along a dashed line */
  Title.loading = function () {
    g.fillStyle = PAL.paper; g.fillRect(0, 0, Game.W, Game.H);
    const cx = 960, cy = 470, x0 = 620, x1 = 1300;
    const prog = (T * 0.35) % 1, sx = lerp(x0, x1, prog);
    for (let x = x0; x < x1; x += 34) ink([[x, cy + 60], [x + 18, cy + 60]], { w: 4, seed: x, alpha: x < sx ? 0.25 : 0.8, passes: 1, step: 20 });
    const open = 0.28 + Math.sin(T * 12) * 0.22;
    g.save(); g.translate(sx, cy + 60);
    [-1, 1].forEach(side => {
      g.save(); g.rotate(side * open);
      ink([[0, 0], [120, -6 * side], [150, 0]], { w: 7, seed: 70 + side, color: PAL.ink, step: 12 });
      ink([[0, 0], [-60, 18 * side]], { w: 7, seed: 72 + side, step: 12 });
      inkCircle(-86, 28 * side, 26, { w: 6, seed: 74 + side, color: side > 0 ? PAL.red : PAL.navy });
      g.restore();
    });
    g.restore();
    hand('cutting paper…', cx, cy + 190, 84, 0, { dur: 0.01, seed: 5 });
  };

  Levels.title = Title;
})();
